import { c as _c } from "react/compiler-runtime";
import { Card } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
import { FeatureRowSkeleton } from '../service-catalog/feature-row';
import { HeaderCatalogPlanSkeleton } from '../service-catalog/header-catalog-plan';
import { SectionHeaderSkeleton } from '../service-catalog/section-header';

/** Full skeleton for the ConfigureServices step (Suspense fallback) */
function ConfigureServicesSkeleton() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-4">{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="border-border flex h-9.5 items-center gap-2 rounded-md border px-3 py-2"><Skeleton className="bg-border h-3.5 w-14" /><Skeleton className="bg-border h-5 w-14 rounded-full" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="border-border flex h-9.5 items-center gap-2 rounded-md border px-3 py-2"><Skeleton className="bg-border h-3.5 w-16" /><Skeleton className="bg-border h-5 w-14 rounded-full" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="border-border flex h-9.5 items-center gap-2 rounded-md border px-3 py-2"><Skeleton className="bg-border h-3.5 w-20" /><Skeleton className="bg-border h-5 w-14 rounded-full" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-center"><div className="flex gap-1">{t1}{t2}{t3}<div className="border-border flex h-9.5 items-center gap-2 rounded-md border px-3 py-2"><Skeleton className="bg-border h-3.5 w-12" /><Skeleton className="bg-border h-5 w-14 rounded-full" /></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HeaderCatalogPlanSkeleton />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-6 flex flex-col gap-6">{t0}{t4}<div className="flex w-full flex-col gap-6 lg:flex-row lg:items-start"><Card className="flex w-full flex-col gap-6 border-none! py-0!"><div className="overflow-hidden rounded-xl">{t5}<div className="flex flex-col"><div><SectionHeaderSkeleton hasOneTimeFee={true} oneTimeFeeSkeletonClassName="w-62!" /><FeatureRowSkeleton labelWidth="w-36" /><FeatureRowSkeleton labelWidth="w-48" /><FeatureRowSkeleton labelWidth="w-28" /></div><div><SectionHeaderSkeleton hasOneTimeFee={true} oneTimeFeeSkeletonClassName="w-24" /><FeatureRowSkeleton labelWidth="w-32" /><FeatureRowSkeleton labelWidth="w-44" /></div><div><SectionHeaderSkeleton /><FeatureRowSkeleton labelWidth="w-32" /><FeatureRowSkeleton labelWidth="w-48" /><FeatureRowSkeleton labelWidth="w-24" /><FeatureRowSkeleton labelWidth="w-52" /></div><div><SectionHeaderSkeleton hasToggle={true} /><FeatureRowSkeleton labelWidth="w-56" /><FeatureRowSkeleton labelWidth="w-44" /></div></div></div></Card></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp(_, i) {
  return <div key={i} className="flex w-full flex-col gap-3"><Skeleton className="bg-border h-4 w-24" /><Skeleton className="bg-border h-8 w-full rounded-md" /></div>;
}
export { ConfigureServicesSkeleton };